module.exports = __webpack_public_path__ + "static/scale-model-of-dckiwi-in-washington-d.c.-4195f68461e3c0e2b8bc8e942dc9051f.png";